export const MATCH_RGX = new RegExp(/\[(.*?)\]/g)

export const DYNAMIC_OPTIONS: Record<string, string> = {
  CURRENCY: "Currency",
  AMOUNT_BILLABLE_VALUE: "Amount Billable Value",
  TAX_AMOUNT_VALUE: "Tax Amount Value",
  TAX_REG_NO_VALUE: "Tax Reg. No. Value",
}

export const DYNAMIC_TAXONOMY_BO_OPTIONS: Record<string, string> = {
  CAMPAIGN_NAME: "Campaign Name",
  MEDIA_PLAN_NAME: "MP Name",
  AGENCY_NAME: "Agency Name",
  CLIENT_NAME: "Client Name",
  CLIENT_PRODUCT_NAME: "(Client) Product Name",
  CLIENT_CODE: "Client Code",
}

export const DYNAMIC_TAXONOMY_LI_OPTIONS: Record<string, string> = {
  CAMPAIGN_NAME: "Campaign Name",
  MP_NAME: "MP Name",
  AGENCY_NAME: "Agency Name",
  MEDIA_TYPE: "Media Type",
  SUBMEDIA_TYPE: "Submedia Type",
  CLIENT_NAME: "Client Name",
  CLIENT_PRODUCT_NAME: "(Client) Product Name",
  CLIENT_CODE: "Client Code",
}

export function interpolate(
  value: string,
  match: RegExp,
  options: Record<string, string>,
) {
  const matches = [...value.matchAll(match)]

  let cursor = 0
  const parts = matches.map((m) => {
    const replace = m[0]
    const option = m[1]
    const text = options[option]

    const simple = value.slice(cursor, m.index)
    const interpolated = text
    cursor = (m.index ?? 0) + replace.length

    return { simple, interpolated, replace, index: m.index }
  })

  const remain = value.slice(cursor, value.length)

  return { parts, remain }
}

export function revertInterpolated(s: string, options: Record<string, string>) {
  let u = s
  Object.keys(options).forEach((opk) => {
    u = u.replaceAll(options[opk], `[${opk}]`)
  })

  return u
}

interface ExtendedSelection extends Selection {
  modify(s: string, t: string, u: string): void
}

/*
  from
  https://stackoverflow.com/a/54333903
*/
export function getCursorPosition() {
  var sel = window.getSelection() as ExtendedSelection
  if (sel) {
    sel.modify("extend", "backward", "documentboundary")
    var pos = sel.toString().length
    if (sel.anchorNode !== undefined) sel.collapseToEnd()

    return pos
  }
  return undefined
}
